import { connect } from 'react-redux';

import { DELETE_PLACE_PROMOTION, DELETE_PROMOTION, DELETE_PROMOTION_DISCOUNT, GET_PROMOTION_LIST } from 'store/promotion/actionTypes';

import Promotions from './Promotions';

const mapStateToProps = (state) => ({
  isLoadingGetPromotionList: state.Promotion.isLoadingGetPromotionList,
  isLoadingDeletePromotion: state.Promotion.isLoadingDeletePromotion,
  isLoadingDeletePlacePromotion: state.Promotion.isLoadingDeletePlacePromotion,
  isLoadingDeletePromotionDiscount: state.Promotion.isLoadingDeletePromotionDiscount,

  promotionList: state.Promotion.promotionList,
  promotionTotal: state.Promotion.promotionTotal,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetListPromotion: (payload) => dispatch({
    type: GET_PROMOTION_LIST,
    payload,
  }),

  actionDeletePromotion: (payload) => dispatch({
    type: DELETE_PROMOTION,
    payload,
  }),

  actionDeletePlacePromotion: (payload) => dispatch({
    type: DELETE_PLACE_PROMOTION,
    payload,
  }),

  actionDeletePromotionDiscount: (payload) => dispatch({
    type: DELETE_PROMOTION_DISCOUNT,
    payload,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Promotions);
